import * as types from './types';

const type = {
  DATA: {
    type: types.GET_COMPANY_DATA,
    method: 'GET'
  },
  CONFIG: {
    type: types.GET_COMPANY_CONFIG,
    method: 'GET'
  },
  PUT: {
    type: types.PUT_COMPANY_PUBR,
    method: 'PUT'
  },
  AGENT: {
    type: types.GET_AGENT_DATA,
    method: 'GET'
  },
  AUTOLOGIN: {
    type: types.GET_AUTOLOGIN,
    method: 'GET'
  },
  BRANCHES: {
    type: types.GET_BRANCHES,
    method: 'GET'
  },
  DEACTIVATE: {
    type: types.POST_BRANCHES_DEACTIVATE,
    method: 'POST'
  },
  ACTIVATE: {
    type: types.PUT_BRANCHES_ACTIVATE,
    method: 'PUT'
  },
  USERS: {
    type: types.GET_COMPANY_USERS,
    method: 'GET'
  },
  USER_PASSWORD: {
    type: types.PASSWORD_COMPANY_USERS,
    method: 'PUT'
  },
  SET_COMMISSION_SHARE: {
    type: types.SET_COMMISSION_SHARE,
    method: 'POST'
  },
  DELETE_COMMISSION_SHARE: {
    type: types.DELETE_COMMISSION_SHARE,
    method: 'DELETE'
  },
  GET_COMMISSION_SHARE: {
    type: types.GET_COMMISSION_SHARE,
    method: 'GET'
  }
};

const controllers = {
  portal: {
    base: '/v1/portal'
  },
  postings: {
    base: '/v1/postings'
  },
  publisher: {
    base: '/api/v1/publisher'
  },
  user: {
    base: '/api/v1/user'
  },
  publisherPanel: {
    base: '/publisher'
  }
};

const apiRequest = ({
  method = 'GET',
  path = '',
  body = {},
  queryParams = {},
  id = '',
  controller = 'publisher',
  headers = null,
  general = false,
  modal = null,
  owner = false,
  api = 'pubr'
}) => ({
  type: type[method].type,
  meta: {
    async: true,
    api,
    path: `${controllers[controller].base}/${path}${id}`,
    general,
    body,
    query: queryParams,
    method: type[method].method,
    section: path,
    headers,
    modal,
    owner
  }
});

const resetUserAccount = () => ({
  type: types.RESET_COMPANY_PUBR,
  meta: {}
});

const resetDeactivateBranch = () => ({
  type: types.RESET_DEACTIVATE,
  meta: {}
});

const resetUserPassword = () => ({
  type: types.RESET_USER_PASSWORD,
  meta: {}
});

const getSharedCommission = (publisherId, portalId) => {
  return {
    type: types.GET_COMMISSION_SHARE,
    meta: {
      async: true,
      blocking: false,
      api: 'avisos',
      path: `/publisher/getCommissionShare/${publisherId}/${portalId}`,
      method: 'GET'
    }
  };
};

const setSharedCommission = (publisherId, portalId, percentage) => ({
  type: types.SET_COMMISSION_SHARE,
  meta: {
    async: true,
    blocking: false,
    api: 'avisos',
    path: `/publisher/saveCommissionShare/${publisherId}/${portalId}?percentage=${percentage}`,
    method: 'POST',
    percentage
  }
});

const deleteSharedCommission = (publisherId, portalId) => ({
  type: types.DELETE_COMMISSION_SHARE,
  meta: {
    async: true,
    blocking: false,
    api: 'avisos',
    path: `/publisher/deleteCommissions/${publisherId}/${portalId}`,
    method: 'DELETE'
  }
});

export {
  apiRequest,
  resetUserAccount,
  resetDeactivateBranch,
  resetUserPassword,
  getSharedCommission,
  setSharedCommission,
  deleteSharedCommission
};
